import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Privacy from '../common/Privacy';
import Footer from '../common/Footer';
import { Helmet } from 'react-helmet';

const Privacypage = () => {
    const location = useLocation();
   useEffect(() => {
         const { search } = location;
         if (!search) {
           window.scroll(0, 0);
         }
       }, []);
  return (
    <>   <Helmet>
    <meta name="keywords" content="services for digital marketing,need digital marketing,full service digital marketing agencies,digital marketing solutions,digital marketing service provider,digital marketing service packages,services for digital marketing,digital marketing price details,Affordable Digital Services,Digital Marketing Pricing & Plans,Digital Marketing Cost in India,whatsapp pricing"/>
  </Helmet>
  <div>
         <Navbar />
      <Privacy/>
      <Footer />
    </div>
</>

  )
}

export default Privacypage
